import React, { useEffect, useState } from "react";
import {
  Box,
  SimpleGrid,
  Card,
  CardBody,
  Text,
  Image,
  VStack,
  HStack,
  Heading,
  Button,
} from "@chakra-ui/react";
import axios from "axios";
import Modal_Pay from "./Modal_Pay";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const ProfileStudent = () => {
  const [borrowedBooks, setBorrowedBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState(false);

  useEffect(() => {
    const fetchMemberIdAndBooks = async () => {
      try {
        const schoolId = sessionStorage.getItem("school_id");
        const studentId = sessionStorage.getItem("student_id");

        if (!schoolId || !studentId) {
          setError("School ID or Student ID is missing.");
          setLoading(false);
          return;
        }

        // Fetch member_id from s_membership_details.php
        const memberResponse = await axios.get(
          `${BASE_URL}/student/library/s_membership_details.php?school_id=${schoolId}&student_id=${studentId}`
        );

        if (memberResponse.data.success) {
          const memberId = memberResponse.data.data.member_id;

          // Fetch borrowed books using member_id
          const bookResponse = await axios.get(
            `${BASE_URL}/admin/library/issues/borrowed_books.php?school_id=${schoolId}&member_id=${memberId}`
          );
          console.log("studentt side borrow", bookResponse);

          if (bookResponse.data.success && bookResponse.data.data.length > 0) {
            setBorrowedBooks(bookResponse.data.data);
          } else {
            setError("No book taken from library.");
          }
        } else {
          setError("Membership details not found.");
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setError("No book taken from library.");
        } else {
          setError("An error occurred while fetching borrowed books.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMemberIdAndBooks();
  }, []);

  if (loading) {
    return <Box p={6}>Loading...</Box>;
  }

  if (error) {
    return <Box p={6}>{error}</Box>;
  }

  // Function to toggle the modal visibility
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Box p={6}>
      {borrowedBooks.length === 0 ? (
        <Box p={6}>No book taken from library.</Box>
      ) : (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {borrowedBooks.map((book) => (
            <Card
              key={book.id}
              variant="outline"
              overflow="hidden"
              boxShadow="sm"
              _hover={{
                boxShadow: "lg",
                transform: "scale(1.02)",
              }}
              transition="all 0.2s ease-in-out"
            >
              <CardBody>
                <VStack align="stretch" spacing={3}>
                  <Image
                    src={
                      book.image_url ||
                      "https://m.media-amazon.com/images/I/81q77Q39nEL._AC_UF1000,1000_QL80_.jpg"
                    }
                    alt={book.title}
                    width="80px"
                    height="80px"
                    objectFit="cover"
                    borderRadius="md"
                    alignSelf="center"
                  />
                  <Box>
                    <Heading size="sm" noOfLines={2} textAlign="center">
                      {book.title}
                    </Heading>
                  </Box>
                  <Box fontSize="sm" color="gray.600">
                    <HStack justify="space-between">
                      <Text fontSize="10px">Book Taken:</Text>
                      <Text
                        fontSize="10px"
                        fontWeight="medium"
                        color="blue.600"
                      >
                        {book.issue_date}
                      </Text>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontSize="10px">Return Date:</Text>
                      <Text
                        fontSize="10px"
                        fontWeight="medium"
                        color="blue.600"
                      >
                        {book.return_date || "Not returned"}
                      </Text>
                    </HStack>
                    <HStack justify="space-between" mt={2}>
                      <Text fontSize="10px">Status:</Text>
                      <Text
                        fontSize="10px"
                        fontWeight="medium"
                        color={
                          book.status === "Returned" ? "green.500" : "red.500"
                        }
                      >
                        {book.status === "Returned"
                          ? "Returned"
                          : "Not Returned"}
                      </Text>
                    </HStack>
                    {book.fine_amount && book.fine_amount !== "0.00" && (
                      <HStack justify="space-between" mt={2}>
                        <Text fontSize="10px">Fine Amount:</Text>
                        <Text
                          fontSize="10px"
                          fontWeight="medium"
                          color="red.500"
                        >
                          ${book.fine_amount}
                        </Text>
                      </HStack>
                    )}
                    {/* Display if the fine has been paid or not */}
                    {book.fine_amount && (
                      <HStack justify="space-between" mt={2}>
                        <Text fontSize="10px">Fine Paid:</Text>
                        <Text
                          fontSize="10px"
                          fontWeight="medium"
                          color={book.paid === 1 ? "green.500" : "red.500"}
                        >
                          {book.paid === 1 ? "Paid" : "Not Paid"}
                        </Text>
                      </HStack>
                    )}
                  </Box>
                  {book.status === "Returned" &&
                    book.fine_amount !== null &&
                    book.paid === 0 && (
                      <Button
                        colorScheme="blue"
                        size="xs"
                        alignSelf="flex-end"
                        mt={4}
                        onClick={() => {
                          handleOpenModal();
                          setData(book);
                        }}
                      >
                        Pay
                      </Button>
                    )}
                </VStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      )}
      {isModalOpen && (
        <Modal_Pay
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          last={data.due_date}
          memberId={data.member_id}
          fineeId={data.fine_id}
          studentId={data.student_id}
          totalAmount={data.fine_amount}
          StudentLedgerId={data.student_ledger_id}
        />
      )}
    </Box>
  );
};

export default ProfileStudent;
